import { Link } from 'react-router-dom'
import { Code2, Server, ArrowRight } from 'lucide-react'
import { useCatalog } from '../../context/CatalogContext'

export default function DocumentationIndex() {
  const { catalog, loading, error } = useCatalog()
  const apis = catalog ? [...catalog.apis].sort((a, b) => a.title.localeCompare(b.title)) : []

  return (
    <div className="docs-index">
      <section className="section docs-index-hero">
        <p className="docs-index-eyebrow">Documentation</p>
        <h1 className="docs-index-title">Getting started</h1>
        <p className="docs-index-sub">
          Everything you need to build on Q-Play - guides for apps and integrations, API
          specifications, and official tooling.
        </p>
      </section>

      <section className="section lp-section">
        <div className="lp-section-head"><h2 className="lp-section-title">Guides & tooling</h2></div>
        <div className="docs-guides-grid">
          <Link to="/docs/app-integration-development" className="lp-promo docs-promo">
            <span className="k">Guides</span>
            <h3>Integration & App Development</h3>
            <p>Build apps and integrations that run on every Q-Play screen - concepts, guides, worked examples, and full reference.</p>
            <div className="docs-promo-tags">
              <span>Overview</span>
              <span>Quickstart</span>
              <span>Examples</span>
              <span>Scripting</span>
            </div>
            <span className="lp-promo-arrow"><ArrowRight size={18} /></span>
          </Link>

          <Link to="/docs/php-composer-module" className="lp-tile">
            <span className="lp-icon lp-icon-chip"><Code2 size={22} /></span>
            <h3>PHP Composer Module</h3>
            <p>Official PHP client for the Q-Play REST API, with OAuth2 authentication built in.</p>
          </Link>
        </div>
      </section>

      <section className="section lp-section" id="api-specifications" style={{ scrollMarginTop: 130 }}>
        <div className="lp-section-head"><h2 className="lp-section-title">API specifications</h2></div>
        {loading && <p>Loading APIs…</p>}
        {error && <div className="card" role="alert">Failed to load APIs catalog: {error}</div>}
        {!loading && !error && apis.length > 0 && (
          <div className="lp-cards lp-cards-3">
            {apis.map((api) => (
              <Link key={api.id} to={`/docs/api-docs/${api.id}`} className="lp-tile">
                <span className="lp-icon lp-icon-chip"><Server size={20} /></span>
                <h3>{api.title}</h3>
                <p>{api.description}</p>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  )
}
